import { useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { apiClient } from '../providers/apiClient';

interface Result { id: string; service: string; model: string | null; output: string | null; error: string | null;
  latencyMs: number; inputTokens: number | null; outputTokens: number | null; costUSD: number | null }

export function BackendModelValidationPanel() {
  const [running, setRunning] = useState(false);
  const [results, setResults] = useState<Result[]>([]);
  const [error, setError] = useState(false);
  return <Box mb={3}>
    <Typography variant="h6">Backend model validation</Typography>
    <Typography variant="body2" color="text.secondary" mb={1}>Nine fixed synthetic cases: seven model calls for translations, memory and a quick-reply capacity probe, plus two checks of the verified crisis directory. Quick reply has no active product caller. Uses provider tokens; saves no user content and charges no hearts. Successful output parsing is not a quality endorsement.</Typography>
    <Button disabled={running} variant="outlined" onClick={async () => {
      setRunning(true); setError(false); setResults([]);
      try { const report = await apiClient.post<{results: Result[]}>('/admin/ai-config/services/validate', {}, { timeout: 90_000, retries: 1 }); setResults(report.results); }
      catch { setError(true); }
      finally { setRunning(false); }
    }}>{running ? 'Validating backend models…' : 'Validate backend models'}</Button>
    {error && <Alert severity="error">Validation failed. Check the provider and try again.</Alert>}
    {results.length > 0 && <Box aria-label="Backend model validation results" mt={2}>
      {results.map(result => <Box key={result.id} p={2} mb={1} bgcolor="action.hover">
        <Typography variant="subtitle1">{result.id} — {result.model ?? 'Model unavailable'}</Typography>
        {result.error && <Alert severity="error">{result.error}</Alert>}
        <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{result.output}</Typography>
        <Typography variant="caption">{(result.latencyMs / 1000).toFixed(2)} s · {result.inputTokens ?? '—'} input / {result.outputTokens ?? '—'} output tokens · {result.costUSD === null ? 'Cost unavailable' : '$' + result.costUSD.toFixed(6)}</Typography>
      </Box>)}
    </Box>}
  </Box>;
}
